import React from 'react';
import { View } from 'react-native';
import { Path, Svg } from 'react-native-svg';

export interface XIconProps {
  size?: number;
  color?: string;
}

export const XIcon: React.FC<XIconProps> = ({
  size = 24,
  color = '#1A1A1A'
}) => {
  return (
    <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
      <Svg width={size} height={size} viewBox="0 0 18 19" fill="none">
        <Path
          d="M13.5 5L4.5 14M4.5 5L13.5 14"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    </View>
  );
};

export default XIcon;